var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 43,
    viewBox: "0 0 81 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_20750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.47764 42.7195C1.68988 42.7195 1.08 42.4938 0.647997 42.0421C0.216 41.5906 0 40.9696 0 40.1792V11.4314C0 10.6411 0.216 10.0202 0.647997 9.56853C1.08 9.11696 1.68988 8.89111 2.47764 8.89111C3.24 8.89111 3.84988 9.11696 4.30729 9.56853C4.7647 10.0202 4.99341 10.6411 4.99341 11.4314V12.2782C6.0861 11.0927 7.21694 10.2319 8.3859 9.69554C9.58024 9.1593 10.927 8.89111 12.4264 8.89111C14.4085 8.89111 16.1365 9.32866 17.6104 10.2036C19.1096 11.0786 20.2532 12.3347 21.041 13.9717C21.8541 15.5806 22.2607 17.4858 22.2607 19.6874C22.2607 21.8608 21.8541 23.7661 21.041 25.4031C20.2277 27.0402 19.0715 28.2963 17.5723 29.1712C16.0729 30.0463 14.3068 30.4837 12.2739 30.4837C10.7492 30.4837 9.41508 30.2297 8.27155 29.7216C7.12802 29.1854 6.04798 28.3386 5.03153 27.1813L4.99341 40.1792C4.99341 40.9696 4.7647 41.5906 4.30729 42.0421C3.84988 42.4938 3.24 42.7195 2.47764 42.7195ZM11.2447 26.0805C13.1252 26.0805 14.5863 25.5301 15.6283 24.4293C16.6955 23.3003 17.2292 21.7197 17.2292 19.6874C17.2292 17.6552 16.6955 16.0887 15.6283 14.9879C14.5863 13.8589 13.1252 13.2943 11.2447 13.2943C9.28798 13.2943 7.75059 13.873 6.63249 15.0302C5.53977 16.1592 4.99341 17.7117 4.99341 19.6874C4.99341 21.6632 5.53977 23.2298 6.63249 24.387C7.75059 25.516 9.28798 26.0805 11.2447 26.0805ZM37.6918 30.4837C36.904 30.4837 36.2942 30.2579 35.8622 29.8063C35.4301 29.3547 35.2142 28.7338 35.2142 27.9434V11.4314C35.2142 10.6129 35.4174 9.99191 35.8241 9.56853C36.256 9.11696 36.8532 8.89111 37.6156 8.89111C38.3779 8.89111 38.9751 9.11696 39.4071 9.56853C39.8391 10.0202 40.0551 10.6411 40.0551 11.4314V12.6592C41.8593 10.1472 44.3243 8.89111 47.4499 8.89111C49.8895 8.89111 51.808 9.75204 53.2057 11.4738C54.6287 13.1673 55.3403 15.4818 55.3403 18.4173V27.9434C55.3403 28.7338 55.1116 29.3547 54.6542 29.8063C54.1968 30.2579 53.5869 30.4837 52.8245 30.4837C52.0367 30.4837 51.4269 30.2579 50.9949 29.8063C50.5628 29.3547 50.3469 28.7338 50.3469 27.9434V18.4173C50.3469 16.8084 49.9911 15.5524 49.2796 14.6491C48.568 13.7459 47.577 13.2943 46.3064 13.2943C44.3751 13.2943 42.8758 13.9294 41.8085 15.1995C40.7412 16.4415 40.2076 18.1915 40.2076 20.4495V27.9434C40.2076 28.7338 39.9789 29.3547 39.5215 29.8063C39.0641 30.2579 38.4542 30.4837 37.6918 30.4837ZM69.6435 40.645C67.6614 40.645 65.8318 40.3204 64.1546 39.6712C62.5024 39.022 61.2064 38.1329 60.2666 37.0039C59.9104 36.5805 59.7329 36.1007 59.7329 35.5643C59.7329 34.8587 60.0379 34.2237 60.6478 33.6591C61.0289 33.3204 61.4351 33.1511 61.8675 33.1511C62.528 33.1511 63.2648 33.5603 64.0783 34.3789C64.6882 34.9999 65.4506 35.4797 66.3654 35.8184C67.3052 36.1853 68.3094 36.3688 69.3767 36.3688C71.3588 36.3688 72.896 35.7055 73.9889 34.3789C75.0812 33.0523 75.6024 31.2176 75.5518 28.8749L75.5136 27.1813C74.6494 28.3104 73.6328 29.1431 72.4642 29.6793C71.3207 30.2156 69.9103 30.4837 68.2332 30.4837C65.1075 30.4837 62.668 29.5382 60.9146 27.6471C59.161 25.7277 58.2843 23.0745 58.2843 19.6874C58.2843 16.3003 59.1737 13.6613 60.9527 11.7701C62.7567 9.85081 65.26 8.89111 68.4619 8.89111C69.7829 8.89111 71.0539 9.18748 72.2736 9.78022C73.4934 10.373 74.5857 11.2056 75.5518 12.2782V11.4314C75.5518 10.6411 75.7805 10.0202 76.2379 9.56853C76.6953 9.11696 77.3052 8.89111 78.0675 8.89111C78.8299 8.89111 79.4267 9.11696 79.859 9.56853C80.3165 9.99191 80.5452 10.6129 80.5452 11.4314V28.8749C80.5452 31.133 80.1003 33.1511 79.2111 34.9293C78.3469 36.7075 77.089 38.1047 75.4374 39.1208C73.8109 40.1369 71.8794 40.645 69.6435 40.645ZM69.2242 26.0805C71.2063 26.0805 72.7561 25.516 73.8746 24.387C74.9925 23.258 75.5518 21.6915 75.5518 19.6874C75.5518 17.6834 74.9925 16.1169 73.8746 14.9879C72.7561 13.8589 71.2063 13.2943 69.2242 13.2943C67.369 13.2943 65.9205 13.8589 64.8788 14.9879C63.8365 16.1169 63.316 17.6834 63.316 19.6874C63.316 21.6915 63.8365 23.258 64.8788 24.387C65.9205 25.516 67.369 26.0805 69.2242 26.0805Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8213 11.9661C28.5837 11.9661 29.1937 12.1919 29.6511 12.6435C30.1085 13.0951 30.3371 13.7161 30.3371 14.5064V28.4034H30.3316L28.0812 33.0308C27.9838 33.2312 27.6916 33.2312 27.5941 33.0308L25.3438 28.4034V14.5064C25.3438 13.7161 25.5597 13.0951 25.9917 12.6435C26.4237 12.1919 27.0336 11.9661 27.8213 11.9661Z",
    fill: "#FF6E79"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_348_20750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9048 -0.00012207C29.8362 -0.000110372 31.4081 0.961807 31.462 2.16113C31.4629 2.18462 31.4634 2.20821 31.4635 2.23185C31.4634 2.23477 31.4633 2.23773 31.4633 2.24066C31.4633 3.16044 30.8904 3.9756 30.0078 4.48101V6.62172C31.1718 7.10933 31.949 7.98956 31.949 8.99446C31.949 8.99735 31.9488 9.00033 31.9488 9.00323C31.9487 9.0269 31.9482 9.05039 31.9472 9.07389C31.8859 10.2732 30.0996 11.2351 27.9048 11.2351C25.71 11.2351 23.9236 10.2732 23.8623 9.07389C23.8613 9.05039 23.8608 9.0269 23.8607 9.00323C23.8607 9.00033 23.8609 8.99735 23.8609 8.99446C23.8609 7.98956 24.6377 7.10933 25.8018 6.62172V4.4811C24.9191 3.97569 24.346 3.16049 24.3459 2.24066C24.346 2.24445 24.3465 2.24826 24.3465 2.25204C24.3464 2.24533 24.3461 2.23858 24.346 2.23185C24.3461 2.20821 24.3466 2.18462 24.3474 2.16113C24.4014 0.961807 25.9734 -0.000112745 27.9048 -0.00012207Z",
    fill: "#FF6E79"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_348_20750",
    x: 23.5943,
    y: -0.266406,
    width: 9.15351,
    height: 12.3004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.266284,
    dy: 0.266284
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.266284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.447059 0 0 0 0 0.501961 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_348_20750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_348_20750",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.532568,
    dy: -0.133142
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.133142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643079 0 0 0 0 0.0291351 0 0 0 0 0.0757102 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_348_20750"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.532568,
    dy: 0.133142
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.133142
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_348_20750",
    result: "effect3_innerShadow_348_20750"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_20750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/Logo_white.f53e278725abaca40b958a5d554424b3.svg";
export { ForwardRef as ReactComponent };